import React, { createContext, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginData } from './redux/Reducers/AuthReducer/authSplice';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
   const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const {  isAuthenticated  } = authState;


  const login = () => {

  };

  const logout = () => {
    // persistSessionId() writes BOTH "session" and "session_id", and
    // getStoredSessionId() falls back from the first to the second. Clearing only
    // "session" therefore left a live session id behind, so requests kept going out
    // authenticated after logout. Clear every key the session is read from.
    localStorage.removeItem('session');
    localStorage.removeItem('session_id');
    dispatch(setLoginData({ user: {}, isAuthenticated: false }));
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
